import React from 'react';
import { Category, Workflow } from './types';
import { MultiselectOption } from '../../../types/multiselect';
import { WorkflowFilters } from './Filters';
import { Input } from '../../common/ui/Input';
import { MultiSelect } from '../../common/ui/Multiselect';

interface DocumentListHeaderProps {
  workflows: Workflow[];
  activeWorkflow: string;
  searchValue: string;
  selectedCategories: Category[];
  availableCategories: Category[];
  activeWorkflowDocumentsCount: number;
  onWorkflowChange: (workflow: string) => void;
  onSearchChange: (search: string) => void;
  onCategoriesChange: (categories: Category[]) => void;
}

export function DocumentListHeader({
  workflows,
  activeWorkflow,
  searchValue,
  selectedCategories,
  availableCategories,
  activeWorkflowDocumentsCount,
  onWorkflowChange,
  onSearchChange,
  onCategoriesChange,
}: DocumentListHeaderProps) {
  const availableOptions: MultiselectOption<Category>[] = availableCategories.map((category) => ({
    value: category,
    label: category.name,
  }));

  const selectedOptions: MultiselectOption<Category>[] = selectedCategories.map((category) => ({
    value: category,
    label: category.name,
  }));

  const handleCategoryChange = (selected: MultiselectOption<Category>[]) => {
    onCategoriesChange(selected.map((option) => option.value));
  };

  return (
    <header className="row g-4 mb-6">
      <h1 className="fs-4 col-12 text-primary text-center">
        Listado de documentos
      </h1>
      <div className="col-12">
        <WorkflowFilters
          workflows={workflows}
          handleWorkflowChange={onWorkflowChange}
          activeWorkflow={activeWorkflow}
          activeWorkflowDocumentsCount={activeWorkflowDocumentsCount}
        />
      </div>
      <div className="col-12 col-md-6 col-lg-4">
        <Input
          type="text"
          placeholder="Buscar documento"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <div className="col-12 col-md-6 col-lg-4">
        <MultiSelect<Category>
          options={availableOptions}
          maxItemsToShow={0}
          value={selectedOptions}
          onChange={handleCategoryChange}
          placeholder="Categorías"
        />
      </div>
    </header>
  );
}
